import React from 'react';
import { isNum, clamp } from './chartUtils';
import './charts.css';

/** One row of cells [{key,label,value}] shaded by value/max (one hue). Null values stay empty. */
const HeatStrip = ({ cells, max, label, valueSuffix = '', testId }) => {
  const list = cells || [];
  const nums = list.filter((c) => isNum(c.value));
  if (!nums.length) return null;
  const top = isNum(max) ? max : Math.max(...nums.map((c) => c.value), 1);
  const w = 100 / list.length;
  const txt = (c) => `${c.label}: ${isNum(c.value) ? `${c.value}${valueSuffix}` : 'none'}`;
  const aria = `${label || 'Heat strip'}: ${list.map(txt).join(', ')}`;
  return (
    <div data-testid={testId}>
      <svg className="pl-chart" role="img" aria-label={aria} width="100%" height="28">
        <title>{aria}</title>
        <desc>Heat strip; darker means a higher value.</desc>
        <rect x="0" y="0" width="100%" height="28" rx="4" fill="var(--chart-track)" />
        {list.map((c, i) => (
          <rect key={c.key} x={`${i * w}%`} y="0" width={`${w}%`} height="28" fill="var(--chart-1)" fillOpacity={isNum(c.value) ? 0.12 + 0.88 * clamp(c.value / top, 0, 1) : 0} stroke="var(--color-bg-white)" strokeWidth="2">
            <title>{txt(c)}</title>
          </rect>
        ))}
      </svg>
      <ul className="pl-chart-legend">
        {list.map((c) => <li key={c.key}>{c.label} <span className="pl-chart-legend__n">{isNum(c.value) ? `${c.value}${valueSuffix}` : '-'}</span></li>)}
      </ul>
    </div>
  );
};

export default HeatStrip;
